import {AxiosRequestConfig} from 'axios'
import store from '@/store'

const DEBUG = false

export function loginAndRedirect() {
	const authServerBaseUrl = store.getters['configModule/authServerBaseUrl']
	const appClientId = store.getters['configModule/appClientId']
	const state = 'abcd1234'
	const appRootUrl = store.getters['configModule/appRootUrl']
	const url =
			authServerBaseUrl +
			'/oauth/authorize?response_type=code&client_id=' +
			appClientId +
			'&state=' +
			state +
			'&redirect_uri=' +
			appRootUrl
	if (DEBUG) console.log('Redirect to URL: ' + url)
	window.location.href = url
}

export function accessTokenRequired(): boolean {
	const accessToken = store.getters['configModule/authToken']
	if (accessToken === null || accessToken.length <= 0) {
		return true
	}
	return false
}

export function requestConfig(): AxiosRequestConfig {
	const accessToken = store.getters['configModule/authToken']
	if (DEBUG) console.log('Using stored accessToken: ' + accessToken)

	return {
		headers: {
			Authorization: accessToken,
		},
	}
}

export function getRequestConfig(): AxiosRequestConfig {
	const accessToken = store.getters['configModule/authToken']
	if (DEBUG) console.log('Using stored accessToken: ' + accessToken)

	return {
		headers: {
			Authorization: accessToken,
		},
	}
}

export function getAccessToken(): string {
	const accessToken = store.getters['configModule/authToken']
	if (DEBUG) console.log('Using stored accessToken: ' + accessToken)
	return accessToken
}
